module.exports = __webpack_public_path__ + "assets/tutta.tv.b4e5a2da135a388f92eff0e62e3b906d2c20e732e8d6964498da37fe39384c9f.jpg";